﻿const History = window.History;

let aseDataModel = {
    month: null,
    monthOptions: [],
    current: null,
    previous: null,
    setPerformanceData: function (data) {
        this.current = data.current;
        this.previous = data.previous || {};
        this.updateTableData();
    },
    getData: function () {
        return { month: this.month.month, year: this.month.year };
    },
    updateUrl: function () {
        const data = this.getData();
        let queryString = `?Month=${data.month}&Year=${data.year}`;
        History.pushState(data, null, location.pathname + queryString);
    },
    getPerformanceData: function (data) {
        $.get("/ase-data/get-data", data, (response) => {
            this.setPerformanceData(response);
        });
    },
    setCurrentMonth: function (month, year) {
        if (month === 0 && year === 0) {
            this.month = this.monthOptions[0]; // select the first option
        } else {
            this.month = this.monthOptions.find(option => option.month === month && option.year === year);
        }
        this.updateSelectedMonthInDOM();
    },
    updateSelectedMonthInDOM: function () {
        document.querySelector("#month").value = this.month.id;
    },
    updateTableData: function () {
        document.getElementById('monthName').textContent = this.month.name;
        let previousDisplayMonth = document.getElementById('previousDisplayMonth');
        if (this.previous && this.previous.displayMonth){
            previousDisplayMonth.textContent = this.previous.displayMonth;
            previousDisplayMonth.style.display = '';
        }
        else{
            previousDisplayMonth.textContent = '';
            previousDisplayMonth.style.display = 'none';
        }

        document.querySelectorAll('[data-current-bind]').forEach(element => {
            const property = element.getAttribute('data-current-bind');
            if (property in this.current) {
                element.textContent = this.current[property];
            }
        });

        document.querySelectorAll('[data-previous-bind]').forEach(element => {
            const property = element.getAttribute('data-previous-bind');
            if (this.previous && property in this.previous) {
                element.textContent = this.previous[property];
                element.parentElement.style.display = ''; // make td visible
            } else {
                element.parentElement.style.display = 'none'; // hide td
            }
        });

        document.querySelectorAll('[data-html-current-bind]').forEach(element => {
            const property = element.getAttribute('data-html-current-bind');
            if (property in this.current) {
                element.innerHTML = this.current[property];
            }
        });
    },
    showPrevious: function () { return this.previous && this.previous.displayMonth != null; }
};

export function setupASELandingPage() {
    if (!$('[data-ase-landing-page]').length) return;

    const monthList = $('#MonthList');
    const monthOptions = $.parseJSON(monthList.val());
    aseDataModel.monthOptions = monthOptions;
    aseDataModel.setCurrentMonth(monthList.data("current-month"), monthList.data('current-year'));

    const monthSelect = document.getElementById('month');
    aseDataModel.monthOptions.forEach(option => {
        const optElement = document.createElement('option');
        optElement.value = option.id;
        optElement.text = option.name;
        monthSelect.appendChild(optElement);
    });

    const performanceData = $.parseJSON($('#PerformanceData').val());
    aseDataModel.setPerformanceData(performanceData);

    document.getElementById('month').addEventListener('change', function() {
        const selectedMonthId = parseInt(this.value);
        const selectedMonth = aseDataModel.monthOptions.find(option => option.id === selectedMonthId);

        if (selectedMonth) {
            aseDataModel.setCurrentMonth(selectedMonth.month, selectedMonth.year);
            aseDataModel.updateUrl();
            aseDataModel.getPerformanceData({ month: selectedMonth.month, year: selectedMonth.year });
        }
    });

    History.Adapter.bind(window, 'statechange', function () {
        const state = History.getState();
        aseDataModel.getPerformanceData(state.data);
    });
}
